/**
 * Centralized API Service
 * All API calls should go through this service
 */

const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

/**
 * Get user's geolocation data
 */
export const getGeoLocation = async () => {
  try {
    const response = await fetch(GEOLOCATION_API, {
      method: 'GET',
      headers: {
        'accept': 'text/plain'
      }
    });

    const data = await response.json();
    
    if (data.isSuccess) {
      return {
        success: true,
        data: data.data
      };
    } else {
      return {
        success: false,
        error: 'Failed to fetch geolocation'
      };
    }
  } catch (error) {
    console.error('Geolocation API Error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Submit lead form data
 * @param {Object} formData - Form data containing name, email, phone, etc.
 * @param {Object} geoData - Geolocation data from getGeoLocation API
 * @param {string} packageTitle - Optional package title
 * @param {number} packageAmount - Optional package amount
 */
export const submitLead = async (formData, geoData = null, packageTitle = '', packageAmount = 0) => {
  try {
    // Get current page URL
    const pageUrl = window.location.href;

    // Extract country code from countryCode (e.g., "+44" -> "44")
    const countryDialCode = formData.countryCode ? 
      parseInt(formData.countryCode.replace('+', '')) : 44;

    // Get country code (2-letter) from geolocation or default to UK
    const country = geoData?.countryCode || 'GB';

    // Prepare payload
    const payload = {
      name: formData.name,
      email: formData.email,
      countryDialCode: countryDialCode,
      country: country,
      phoneNumber: formData.phone, // Only digits, no country code prefix
      ipAddress: geoData?.ipAddress || '',
      description: formData.message || 'Trademark registration inquiry',
      pageUrl: pageUrl,
      city: geoData?.cityName || '',
      state: geoData?.regionName || '',
      geoLocation: geoData ? JSON.stringify({ 
        isSuccess: true, 
        data: geoData, 
        errorMessage: '', 
        statusCode: 200 
      }) : '',
      packageTitle: packageTitle,
      packageAmount: packageAmount
    };

    console.log('Lead API Payload:', payload);

    const response = await fetch(LEAD_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    const statusCode = response.status;

    console.log('Lead API Response:', data, 'Status:', statusCode);

    // Handle different status codes
    if (statusCode === 200 && data.isSuccess) {
      return {
        success: true,
        customerId: data.data.customerId,
        message: data.data.message
      };
    } else if (statusCode === 401) {
      return {
        success: false,
        error: data.message || 'Unauthorized access'
      };
    } else if (statusCode === 400) {
      return {
        success: false,
        error: data.errorMessage || 'Invalid data provided'
      };
    } else {
      return {
        success: false,
        error: data.errorMessage || 'Something went wrong'
      };
    }
  } catch (error) {
    console.error('Lead API Error:', error);
    return {
      success: false,
      error: 'Failed to submit form. Please try again.'
    };
  }
};

/**
 * Get country code mapping for country name to 2-letter code
 */
export const getCountryCode = (countryName) => {
  const countryMap = {
    'United Kingdom': 'GB',
    'United States': 'US',
    'Pakistan': 'PK',
    'India': 'IN',
    'Canada': 'CA',
    'Australia': 'AU',
    'Ireland': 'IE',
    'Netherlands': 'NL',
    // Add more as needed
  };
  return countryMap[countryName] || 'GB';
};
